import {createSelector} from 'reselect';
import {generateOrderItem, getItemPrice} from '../../helpers/common';
import {DeliveryType} from '../../constants/deliveryTypes';

const selectOrderItems = (state) => {
  return state.orderItems;
};

const selectOrderPayments = (state) => {
  return state.payments;
};

const selectCurrentDeliveryType = (state) => {
  return state.currentDeliveryType;
};

const selectBranchInfo = (state) => {
  return state.branchInfo;
};

const selectCostDelivery = (state) => {
  return state.costDelivery;
};

const selectMenuItemTypes = (state) => {
  return state.menuItemTypes;
};

const selectValuecardOrderItem = (state) => {
  return state.valuecardItem;
};

// const selectRoundSetting = (state) => {
//   return state.orderInfo.round_format || 0;
// };

const selectOrderRoundSetting = (state) => {
  return state.branchInfo.RoundFormat || 0;
};

export const currentDeliveryItem = createSelector(
  [selectOrderItems, selectOrderRoundSetting, selectBranchInfo, selectMenuItemTypes, selectCurrentDeliveryType, selectCostDelivery, selectValuecardOrderItem],
  (orderItems, roundFormat, branchInfo, menuItemTypes, currentDeliveryType, costDelivery, valuecardItem) => {
    if (currentDeliveryType === DeliveryType.TA || currentDeliveryType === DeliveryType.EAT_IN) {
      return null;
    }

    const deliveryItemPresent = costDelivery > 0 && branchInfo.DeliveryItem;
    if (!deliveryItemPresent) {
      return null;
    }

    const valueCardPrice = valuecardItem ? valuecardItem.orderItem.price : 0;
    const total = orderItems.reduce(totalSumReducer, 0) + valueCardPrice;
    const orderSubtotal = +(roundSum(total / 100, roundFormat) * 100).toFixed(2);

    if (deliveryItemPresent && +branchInfo.AddDeliveryItem > 0 && +branchInfo.AddDeliveryItem <= orderSubtotal) {
      return null;
    }

    return generateOrderItem(branchInfo.DeliveryItem, menuItemTypes, {customPrice: +costDelivery});
  }
);

export const orderTotal = createSelector(
  [selectOrderItems, selectOrderRoundSetting, selectBranchInfo, selectCurrentDeliveryType, selectCostDelivery, selectValuecardOrderItem],
  (orderItems, roundFormat, branchInfo, currentDeliveryType, costDelivery, valuecardItem) => {
    const total = orderItems.reduce(totalSumReducer, 0);
    const valueCardDiscount = valuecardItem ? valuecardItem.orderItem.price : 0;
    const orderSubtotal = +(roundSum((total + valueCardDiscount) / 100, roundFormat) * 100).toFixed(2);

    const deliveryItemPresent = (+costDelivery > 0 && branchInfo.DeliveryItem) && currentDeliveryType === DeliveryType.DELIVERY;
    const shouldAddDeliveryItem = deliveryItemPresent && (+branchInfo.AddDeliveryItem === 0 || (+branchInfo.AddDeliveryItem > 0 && +branchInfo.AddDeliveryItem > orderSubtotal));

    return (deliveryItemPresent && shouldAddDeliveryItem) ? orderSubtotal + +costDelivery : orderSubtotal;
  }
);

export const orderSubTotal = createSelector(
  [selectOrderItems, selectOrderRoundSetting, selectValuecardOrderItem],
  (orderItems, roundFormat, valuecardItem) => {
    const total = orderItems.reduce(totalSumReducer, 0);
    const valueCardDiscount = valuecardItem ? valuecardItem.orderItem.price : 0;
    return +(roundSum((total + valueCardDiscount) / 100, roundFormat) * 100).toFixed(2);
  }
);

export const orderPaidTotal = createSelector(
  [selectOrderPayments],
  (payments) => {
    return payments.reduce(totalPayedSumReducer, 0);
  }
);

export const orderToPay = createSelector(
  [selectOrderItems, selectOrderPayments, selectOrderRoundSetting, selectValuecardOrderItem],
  (orderItems, payments, roundFormat, valuecardItem) => {
    const total = orderItems.reduce(totalSumReducer, 0);
    const valueCardDiscount = valuecardItem ? valuecardItem.orderItem.price : 0;
    const orderSubtotal = +(roundSum((total + valueCardDiscount) / 100, roundFormat) * 100).toFixed(2);
    return orderSubtotal - payments.reduce(totalPayedSumReducer, 0);
  }
);

const roundSum = (total, roundSetting) => {
  const rules = [1, 10, 100];
  const rule = rules[roundSetting];
  return (Math.round(total * rule) / rule).toFixed(2);
};

const totalPayedSumReducer = (total, payment) => {
  const amount = payment.amount - (payment.round_amount ? payment.round_amount : 0);
  return total + amount;
};

const totalSumReducer = (total, item) => {
  // if (!item.orderItem.price) return total;

  let itemPrice = getItemPrice(item, true, true, false);

  if (item.orderItem.discount_type === 2) {
    itemPrice = Math.ceil(itemPrice);
  }

  // let itemPrice = item.orderItem.price;
  //
  // switch (item.orderItem.discount_type) {
  //   case 2:
  //     itemPrice -= (itemPrice * (item.orderItem.discount / 10000));
  //     break;
  //   case 1:
  //     itemPrice -= item.orderItem.discount;
  //     break;
  //   default:
  //     break;
  // }
  // itemPrice *= item.orderItem.quantity;

  // if (currentOrderTable.discount_type === 2 && !curr.block_change_price_flg) {
  //   itemPrice -= (itemPrice * (currentOrderTable.discount / 10000));
  // }
  // if (currentOrderTable.discount_type === 1 && !curr.block_change_price_flg) {
  //   itemPrice -= currentOrderTable.discount;
  // }

  return total + itemPrice;
};
